import { render, staticRenderFns } from "./Pregnancy.vue?vue&type=template&id=50a26dc4&"
import script from "./Pregnancy.vue?vue&type=script&lang=js&"
export * from "./Pregnancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports